/**
 * '통합 비용 및 성과 대시보드' 조회 기간 기억 (2026-10-01, 정산 작업 속도).
 *
 * 정산할 때 관리자는 채널(계정)을 바꿔 가며 같은 기간을 본다. 채널 전환은 같은 탭에서 `window.location.reload()`
 * 로 처리되고(`Layout.js`), 대시보드는 마운트될 때마다 기간을 '이번 달 1일 ~ 오늘'로 되돌렸다 → 채널마다 다시 골라야 했다.
 *
 * - **관리자(`isSystemAdmin`)일 때만 저장한다.** 이 화면은 고객도 쓰는데, 고객의 기본 동작(이번 달)은 바꾸지 않는다.
 *   읽기는 저장값이 있을 때만 쓰므로 고객 브라우저에서는 아무 일도 없다.
 * - **localStorage** 에 둔다 — 요청이 "마지막에 설정한 기간이 계속 고정" 이라 새 탭·다음 날에도 유지돼야 한다.
 *   (sysadmin 기준월 `baseMonth.js` 가 sessionStorage 인 것과 다르다 — 그쪽은 '그 순간의 작업 문맥'.)
 *   오래된 기간이 남는 것은 화면 상단 날짜와 '이번 달로' 버튼으로 드러낸다.
 * - 저장소 접근이 막혀도(시크릿 모드 등) 화면은 그대로 동작하고 유지만 안 된다.
 */
const KEY = 'omoplay.dashboard.period';
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

const fmt = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const parse = (s) => {
  if (!DATE_RE.test(s ?? '')) return null;
  const [y, m, d] = s.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return date.getMonth() === m - 1 && date.getDate() === d ? date : null;
};

/** 기본 기간 = 이번 달 1일 ~ 오늘(종전 동작). */
export const defaultPeriod = () => {
  const now = new Date();
  return { start: new Date(now.getFullYear(), now.getMonth(), 1), end: now };
};

/** 저장된 기간. 없거나 깨졌으면 null. */
export const readStoredPeriod = () => {
  try {
    const raw = JSON.parse(window.localStorage.getItem(KEY) ?? 'null');
    const start = parse(raw?.start);
    const end = parse(raw?.end);
    return start && end && start <= end ? { start, end } : null;
  } catch {
    return null;
  }
};

export const storePeriod = (start, end) => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ start: fmt(start), end: fmt(end) }));
  } catch {
    // 유지만 안 될 뿐 화면 동작은 그대로.
  }
};

export const clearStoredPeriod = () => {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // noop
  }
};
